// components/skeletons/HeaderSearchSkeleton.tsx
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function HeaderSearchSkeleton() {
  return (
    <div className="tw-w-full tw-pt-4 tw-pb-3">
      <Skeleton
        height={44}
        borderRadius={8}
        className="tw-w-full"
        containerClassName="tw-w-full"
      />
    </div>
  );
}
